import script from "./TwoFactorAuthDisableModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthDisableModal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__